import styled, { css } from 'styled-components';

type BackTextProps = {
  text: string;
};

const StyledBackText = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.main.accent};
    transition: 0.35s ease;
    font-weight: 600;

    .material-symbols-rounded {
      font-size: 1.25rem;
    }

    @media (hover: hover) {
      &:hover {
        color: ${theme.colors.main.secondary};
      }
    }
  `
);

const BackText = ({ text }: BackTextProps) => {
  return (
    <StyledBackText>
      <span className="material-symbols-rounded">arrow_back_ios</span>
      {text}
    </StyledBackText>
  );
};

export { BackText };
